import { render, staticRenderFns } from "./FabButton.vue?vue&type=template&id=71d64895&scoped=true&"
import script from "./FabButton.vue?vue&type=script&lang=js&"
export * from "./FabButton.vue?vue&type=script&lang=js&"
import style0 from "./FabButton.vue?vue&type=style&index=0&id=71d64895&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d64895",
  null
  
)

export default component.exports